<template>
  <div class="left-sidebar">
    <el-menu :default-active="obj.menuIdx" active='0' style="width:60px;padding-top:60px" background-color="#262f3e"
      text-color="#c1c6c8" active-text-color="#ffffff" :style="'height:' + (this.$store.state.windowHeight) + 'px'"
      :collapse="true" @select="handleSelect">
      <el-menu-item index="0">
        <el-icon>
          <back />
        </el-icon>
        <template #title>返回</template>
      </el-menu-item>
      <el-menu-item index="1">
        <el-icon>
          <refresh />
        </el-icon>
        <template #title>刷新</template>
      </el-menu-item>
      <el-menu-item index="2">
        <el-icon>
          <star />
        </el-icon>
        <template #title>自选</template>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  setup(props, { emit }) {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      menuIdx: '',
    })

    // 页面传来的menuIdx处理
    vueEvent.on('sidebarMenuIdxEvent', (menuIdx) => {
      obj.menuIdx = menuIdx
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      vueEvent.off('sidebarMenuIdxEvent')
    })

    // 菜单点击事件
    const handleSelect = (menuIdx) => {
      emit('sidebarEvent', menuIdx) // 抛出事件到父组件
      if (menuIdx === '0') {
        router.back()
      } else if (menuIdx === '1') {
        router.go(0)
      } else if (menuIdx === '2'){
        vueEvent.emit('favoritesDialogVisible',true)
      }
    }

    return {
      obj,
      handleSelect
    }
  }
}
</script>
<style lang="scss" scoped>
.left-sidebar {
  left: 0;
  top: 0;
  position: fixed;
  width: 60px;
  background-color: white;
  z-index: 10;
}
</style>
